/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/owl'
export default icon
